module.exports = __webpack_public_path__ + "img/tableau.fde6668c.svg";